import { render } from "./ResultItemSkeleton.vue?vue&type=template&id=07dfde12&scoped=true"
import script from "./ResultItemSkeleton.vue?vue&type=script&lang=js"
export * from "./ResultItemSkeleton.vue?vue&type=script&lang=js"

import "./ResultItemSkeleton.vue?vue&type=style&index=0&id=07dfde12&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07dfde12"]])

export default __exports__